var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRainDayIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.2,
    height: 24.006,
    viewBox: "0 0 24.2 24.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rain-day-icon",
    transform: "translate(0.148 0.006)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 24,
    height: 24,
    fill: "#fcfcfc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.994 1)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line",
    y2: 8,
    transform: "translate(15.006 12)",
    fill: "none",
    stroke: "#388cff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-2",
    "data-name": "Line",
    y2: 8,
    transform: "translate(7.006 12)",
    fill: "none",
    stroke: "#388cff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-3",
    "data-name": "Line",
    y2: 8,
    transform: "translate(11.006 14)",
    fill: "none",
    stroke: "#388cff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M19.835,16.414a5,5,0,0,0-2-9.581h-1.26a8,8,0,1,0-12.74,8.25",
    transform: "translate(-0.828 -0.833)",
    fill: "none",
    stroke: "#364456",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainDayIcon);
export default __webpack_public_path__ + "static/media/rain-day-icon.b0ff2c84b72354ae53d2cc305688a92b.svg";
export { ForwardRef as ReactComponent };